import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SurveysConfirmComponent } from '../../shared/dialogs/surveys-confirm/surveys-confirm.component';
import jwt_decode from 'jwt-decode';
import { ActivatedRoute, Router } from '@angular/router';
import { MainService } from 'src/app/services/main.service';
import { SurveysService } from 'src/app/services/surveys.service';
import { Title } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { SurveyImageSliderComponent } from '../../shared/dialogs/survey-image-slider/survey-image-slider.component';
import Swal from 'sweetalert2';
import { SurveysComentaryComponent } from '../../shared/dialogs/surveys-comentary/surveys-comentary.component';

@Component({
  selector: 'app-surveys-view',
  templateUrl: './surveys-view.component.html',
  styleUrls: ['./surveys-view.component.scss']
})
export class SurveysViewComponent implements OnInit {

  constructor(private matDialog: MatDialog,  
              private _params: ActivatedRoute,
             private _router : Router,
             private surveyS : SurveysService,
             private main : MainService,
             private _titleService: Title,)
  {
    this.loading = true;
    this._params.params.subscribe(params => {
      if(params.id){
        this.encuestaIds = jwt_decode(params.id!);
     
        this.isClaw_survey = this.encuestaIds.box_id? true : false;
        console.log(this.encuestaIds, this.isClaw_survey);
        this.id_campana_claw = this.isClaw_survey? this.encuestaIds.id_campana : 0;
      }else{
        this._router.navigateByUrl('/admin/dashboard');
      } 
    });
   }

   isClaw_survey : boolean = false;
   encuestaIds : any = {};
   encuestaData : any = {};
   loading : boolean = false; 
   id_campana_claw : any;
   productListEvaluated :any[] = [];
   private apiURL = environment.API_URL;
   company = environment.nest_company;
   urlImage = this.apiURL + "/surveys/image/";
   //urlHoot = environment.HOOT_URL;
   fecha_entrega: string = '';
   dias_encuesta: number = 0;
   fecha_actual: Date = new Date();
   fecha_limite: Date = new Date();
   fuera_tiempo: boolean = false;

   ingresa_clave: boolean = false;
   input_clave: string = '';

   idExtLabel : string = environment.alias.id_ext;

    estatusMappingTable: any = {
      assigned: { label: 'En tránsito', color: 'bg-primary' },
      order_created: { label: 'Esperando recolección', color: 'bg-purple' },
      order_completed: { label: 'Recolectado', color: 'bg-info' },
      started: { label: 'En ruta de entrega', color: 'bg-warning' },
      successful: { label: 'Entregado', color: 'bg-success' },
      'entrega dedicada': { label: 'Entregado', color: 'bg-success' },
      error: { label: 'Incidencia', color: 'bg-danger' },
      incident: { label: 'Incidencia', color: 'bg-danger' },
      canceled: { label: 'Incidencia', color: 'bg-danger' },
      'return': {label:'Devolución', color: 'bg-danger'},
      '1': { label: 'Incidencia', color: 'bg-danger' },
      '': { label: 'Incidencia', color: 'bg-danger' },
    }

  ngOnInit(): void {
    this.loadEncuestas();
  }

  loadEncuestas(){
    this.main.ShowLoading();
    this.surveyS.getSurveyView(this.encuestaIds.id_campana, this.encuestaIds.id_sucursal, this.isClaw_survey ? this.encuestaIds.box_id : 0).subscribe((x:any)=>{
        if(x.message == "Success"){
          console.log("nest comp", this.company);
          this.encuestaData = x.data;

          /* console.log("Encuestas data")
          console.log(this.encuestaData) */

          const sessionKey = `encuesta_auth_${this.encuestaData.surveyData.id_campana}_${this.encuestaData.surveyData.sucursal}`;
          const validadaClave = localStorage.getItem(sessionKey);

          if(this.encuestaData.surveyData.auth_encuestas == 0 || validadaClave === 'true'){ //Verifica si necesita ingresar clave
            this.ingresa_clave = true;
          }
          if(this.isClaw_survey){
            console.log(this.encuestaData);
            this.productListEvaluated = x.data.surveyData.materiales.map((x:any)=> {  return {id : x.id, cantidad : x.cantidad, nombre : x.nombre, nombre_mat : x.nombre_mat, status : x.status, images : x.images, alerted : false, cantidad_pza: x.cantidad_pza, comentario : "", tickets: x.tickets}} );
            this._titleService.setTitle("Buho Nest Encuestas - " + this.encuestaData.campana.name + " - " + this.encuestaData.surveyData.sucursal );
            this.answered = this.encuestaData.surveyData.survey_status==1;
          }else{
            this.productListEvaluated = x.data.surveyData.map((x:any)=> {  return {id : x.id, cantidad : x.cantidad, id_material_camp : x.id_material_camp,
            id_zona : x.id_zona, nombre : x.nombre, nombre_mat : x.nombre_mat, status : x.status, images : x.images, alerted : false, cantidad_pza: x.cantidad_pza, comentario : ""}} );
            this._titleService.setTitle("Buho Nest Encuestas - " + this.encuestaData.campana.name + " - " + this.encuestaData.sucursal.nombre );
            this.encuestaData.surveyData["consec"] = this.encuestaData.consec.consec;
            this.encuestaData.surveyData["sucursal"] = this.encuestaData.sucursal.nombre;
            this.answered = this.isSurveyAsnswered();
          }

          //Calcular fecha limite para contestar encuesta
          this.fecha_entrega = this.encuestaData.surveyData.fecha_entrega;
          this.dias_encuesta = this.encuestaData.surveyData.dias_encuesta;

          if(this.fecha_entrega != null && this.dias_encuesta != null){
            this.fecha_limite = new Date(this.fecha_entrega);

            const diaActual: number = this.fecha_limite.getDate();
            this.fecha_limite.setDate(diaActual + this.encuestaData.surveyData.dias_encuesta);

            if(this.fecha_limite < this.fecha_actual){
              this.fuera_tiempo = true;
            }
          }
          
          this.loading = false;
        }else{
          this._router.navigateByUrl('/admin/dashboard');
        }
        this.main.HideLoading();
    });
  }

  // 1-pendiente 2-correcto 3-alerta

  openConfirm() {
    this.matDialog.open(SurveysConfirmComponent, {
      panelClass: 'dialogs-main',
      data: {
        id_campana : this.encuestaData.campana.id,
        sucursal : this.isClaw_survey?this.encuestaData.campana.sucursal:this.encuestaData.sucursal,
        box_id : this.isClaw_survey? this.encuestaIds.box_id : 0,
        isClaw : this.isClaw_survey,
        id_campana_claw  : this.isClaw_survey ? this.id_campana_claw : 0,
        productListEvaluated : this.productListEvaluated
      }
    }).afterClosed().subscribe(
      resp => {     
        if(resp){
          console.log("confirmado", resp);
          this.loadEncuestas();
        }
      }
    );
  }

  answered = true;

  private isSurveyAsnswered() : boolean{
    console.log(this.productListEvaluated.some((x:any) => x.status != 1));
   return this.productListEvaluated.some((x:any) => x.status != 1)
  }

  getEstafeta():string{
    if(this.encuestaData.surveyData.length>0){
      return this.encuestaData.surveyData[0].estafeta;
    }else{
      return "-"
    }
  }

  getProductStatusObj(idstatus : number):any{
      return environment.status_surveys.filter(x=> x.id  == idstatus)[0];
  }

  getMaterialImage(id:number, nombre : string, images : any){
        if(images !=0){
          this.matDialog.open(SurveyImageSliderComponent, {
            panelClass: ['dialog-img-lg'],
            data: {
              images : images,
              material_info : nombre,
              campana : null
            }
          }).afterClosed().subscribe(
            resp => {
              if(resp?.reload) {
                
              }
            }
          );
        }
  }

  toggleAlerta(event : any, product : any){
   if(!event.checked){
     product.comentario = "";
   }else{

     this.matDialog.open(SurveysComentaryComponent, {
       panelClass: 'dialogs-main',
       data: {
         product : product,
         isClaw : this.isClaw_survey
       }
     }).afterClosed().subscribe(
       resp => {     
         if(resp){

         }else{
          
           product.comentario = "";
           product.alerted = false;
         }
       }
     );

   }
    console.log(event.checked , product);
    
  }

  validaClave(){

    //si no existe el id_ext, validar por nombre de sucursal
    let clave_a_validar = (this.encuestaData.surveyData.id_ext == null || this.encuestaData.surveyData.id_ext == '') ? this.encuestaData.surveyData.sucursal : this.encuestaData.surveyData.id_ext;

    if(this.input_clave == clave_a_validar){

      const sessionKey = `encuesta_auth_${this.encuestaData.surveyData.id_campana}_${this.encuestaData.surveyData.sucursal}`;
      localStorage.setItem(sessionKey, 'true');

      Swal.fire({
        title: 'Espere...',
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        },
        timer: 1000
      }).then(() => {
        this.ingresa_clave = true;
      });
        this.ingresa_clave = true;

    }
    else{
      Swal.fire({
        icon: 'warning',
        title: 'Atención',
        text: 'Clave incorrecta',
        allowOutsideClick: false,
        showConfirmButton: true
      })
    }
  }

  getStatusTrackingDat(idstatus : number){
    return environment.status_seguimientos.filter(x=> x.id  == idstatus)[0];
  }
  getStatusTicketsDat(idstatus : number){
    return environment.status_ticket.filter(x=> x.id  == idstatus)[0];
  }
  isDedicated(row_sts : any){
    if(row_sts.tracking_number.toLowerCase() === 'entrega dedicada' && row_sts.status_guia === null){
      return true
    }else{
      return false;
    }
  }



}
